import { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
import { Modal, Button, Badge } from "react-bootstrap";
import { useUserAuth } from "../../context/UserAuthContext";
import TtkContainerStatusMgmt from "../thinksToKnowStatusMgmt/ttkContainerStatusMgmt";

const ThinksToKnowStatus = () => {
    const { user } = useUserAuth();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const fetchMetaData = async () => {
        if (!user?.uid) return
        setLoading(true);
        try {
            const response = await axios.get(
                `${base_url}/api/v1/meta-data/meta/${user?.uid}`,
            );
            const res = response.data.data
            // const filtered = res.filter(
            //     (item) => item.table_name === "thinkstoknow"
            // );
            setData(response.data.data || []);
        } catch (error) {
            console.error("Error fetching meta data:", error);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (user) {
            fetchMetaData();
        }
    }, [user]);
    return (
        <div>
            <div className="col-md-12">
                <div className="card shadow-sm ">
                    <div className="card-body">
                        <h5 className="mb-2">Thinks To Know Details Change</h5>
                        {loading ? (
                            <Skeleton height={20} count={2} />
                        ) : data ? (
                            <>
                                {/* Last change text */}
                                <p className="text-muted mb-2">
                                    {data.remark}
                                </p>
                                {/* Status */}
                                <Badge
                                    bg={
                                        data.status === "approved"
                                            ? "success"
                                            : data.status === "rejected"
                                                ? "danger"
                                                : "warning"
                                    }
                                    className="mb-3"
                                >
                                    {data?.status?.toUpperCase()}
                                </Badge>

                                <div className="d-flex justify-content-between align-items-center">
                                    <small className="text-muted">
                                        {dayjs(data.requested_at).format("DD MMM YYYY, hh:mm A")}
                                    </small>

                                    <Button
                                        size="sm"
                                        variant="info"
                                        onClick={() => {
                                            setSelectedItem(data);
                                            setShowModal(true);
                                        }}
                                    >
                                        View Changes
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <p className="text-muted">No change request found</p>
                        )}
                    </div>
                </div>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Things To Know Data</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "100vh", overflowY: "auto" }}>
                    {selectedItem && (
                        <TtkContainerStatusMgmt
                            data={selectedItem.data}
                            sub_cat_id={selectedItem.sub_category_id}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ThinksToKnowStatus
